const messages = {
  topbar: {
    kolobrzeg: "Kolberg",
    back: "Rückkehr",
    favourites: "Zwischenablage ",
    chooseFloorOrFlat: "Wählen Sie ein Stockwerk oder eine Wohnung",
    chooseFloor: "Wählen Sie ein Stockwerk",
    chooseFlat: "Wählen Sie eine Wohnung",
    chooseBuilding: "Wählen Sie eine Gebäude",
    chooseInvestment: "Wählen Sie ein Investition",
    filtering: "Filtern",
  },
  flat: "Wohnung",
  floor: "Stockwerke",
  building: "Gebäude ",
  groundFloorShortcut: "P",
  tooltip: {
    flatNumber: "Anzahl der Wohnungen",
    available: "Verfügbar",
    booked: "Reserviert",
    sold: "Verkauft",
  },
  singleFlat: {
    area: "Bereich",
    floor: "Stockwerke",
    groundFloor: "Erdgeschoss",
    rooms: "Räume",
    price: "Prise",
    status: "Status",
    num: "Nr",
    noPrev: "Keine Vorschau",
    similar: "Ähnliche Wohnungen",
    askPrice: "Fragen Sie nach einem Preis",
    closeForm: "Schließen Sie das Formular",
    downloadPDF: "PDF Datei herunterladen",
  },
  singleBuilding: {
    loading: "Laden von 3D-Modulen",
  },
  form: {
    title: "Nach einer Wohnung fragen ",
    name: "Vor und Nachname",
    name_error: "Bitte geben Sie Ihren Namen an",
    email: "E-mail",
    email_error: "Bitte E-Mail angeben",
    phone: "Telefonnummer",
    phone_error: "Bitte geben Sie mir Ihre Telefonnummer",
    message: "Nachricht",
    message_error: "Bitte schreiben Sie eine Nachricht",
    check_error: "Bitte genehmigen",
    submit: "Fragen Sie nach der Wohnung",
    sent: "Gesendet an",
  },
  filters: {
    criteria: "Erfüllt die Kriterien",
    remove: "Filter entfernen",
    amenities: "Einrichtungen",
    balcony: "Balkon",
    garden: "Garten",
    search: "Suchen",
  },
  favourites: {
    noCriteria: "Keine den Anforderungen entsprechende Wohnung",
    noFavs: "Keine Unterkunft in einem Schließfach",
    placeholder: "Name eingeben...",
    sortBy: "Sortieren nach",
    sorting: "Sortierung auswählen",
    openSort: "Sortieroptionen öffnen",
    findFlat: "Wohnung durchsuchen",
    ascending: "zunehmend",
    descending: "abnehmend",
    flatsIn: "Leben in der Zwischenablage",
    delete: "Alle löschen",
  },
  pageNotFound: "Es gibt keine solche Seite",
  homepage: "Gehen Sie zur Startseite",
  loadingFlats: "Laden von Wohnungen",
  from: "von",
  to: "bis",
  surface: "Bereich",
  rooms: "Räume",

  agreeInfoShort: `Der Administrator der persönlichen Daten ist das Unternehmen Vacation Investments Sp. z o.o. mit Sitz in Mokotowska 57/19, Warschau...`,
  agreeInfo: `Der Administrator der persönlichen Daten ist das Unternehmen Vacation Investments Sp. z o.o. mit Sitz in Mokotowska 57/19, Warschau. Sie haben das Recht, auf Ihre personenbezogenen Daten zuzugreifen, diese zu löschen, zu ändern, die Verarbeitung einzuschränken und die Zustimmung zu deren Verarbeitung zu widerrufen. Die Angabe von persönlichen Daten ist freiwillig, mit dem Absenden des Formulars stimmen Sie der Verarbeitung zu. Ihre Daten werden für Marketingzwecke auch mit Hilfe automatisierter Profilerstellung verarbeitet.
Rechtsgrundlage für die Verarbeitung Ihrer personenbezogenen Daten ist Art. 6 Abs.1 lit. a DSGVO, d. h. Zustimmung, falls erteilt, oder Art. 6 Abs. 1 lit. f DSGVO (wichtiges Interesse des Administrators, Direktmarketing). Gegenstand der verarbeiteten personenbezogenen Daten sind Vor- und Nachname, Funktion, Telefon, E-Mail-Adresse. Die Daten werden gespeichert, bis Sie Widerspruch einlegen. Die Kontaktaufnahme mit den Verantwortlichen für die Datenverarbeitung ist per E-Mail möglich: marketing@hotelbalticwave.pl, Tel.: +48 882 784 606, und per Post an die Adresse des eingetragenen Sitzes.`,
  agree1Short: `Ich bin damit einverstanden, von Vacation Investments...`,
  agree1: `Ich bin damit einverstanden, von Vacation Investments Sp. z o.o. Informationen zu Marketing und kommerziellen Inhalten unter der angegebenen E-Mail-Adresse zu erhalten.`,
  agree2Short: `Ich bin damit einverstanden, von Vacation Investments...`,
  agree2: `Ich bin damit einverstanden, von Vacation Investments Sp. z o.o. Informationen zu Marketing und kommerziellen Inhalten unter der angegebenen Telefonnummer zu erhalten.`,
  agree3Short: `Ich stimme der Verarbeitung meiner persönlichen Daten durch Vacation Investments...`,
  agree3: `Ich stimme der Verarbeitung meiner persönlichen Daten durch Vacation Investments Sp. z o.o. zum Zwecke der Vermarktung der von Vacation Investments Sp. z o.o. angebotenen Produkte und Dienstleistungen zu.`,
  cardsView: "Karten",
  listView: "Liste",
  apartment: "Apartment",
  addToFavs: "Zu den Favoriten hinzufügen",
  removeFromFavs: "Von Favoriten entfernen",
  loadMore: "Mehr laden",
  matchingFlatsInfo: "Wohnungen, die ihre Kriterium erfüllen",
};

export default messages;
